import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link, useParams } from 'react-router-dom';

const PageHeader = () => {
  const { bulkId } = useParams();
  const isEditing = !!bulkId;

  return (
    <div className="mb-6" data-testid="page-header">
      <div className="flex items-center gap-3 mb-1">
        <Link to="/admin/bulk-history">
          <Button variant="ghost" size="sm" className="h-8 px-2 text-slate-500 hover:text-slate-700">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Prøver
          </Button>
        </Link>
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
        {isEditing ? 'Rediger prøve' : 'Ny prøveregistrering'}
      </h1>
      <p className="text-sm text-slate-500 mt-1">
        {isEditing ? 'Oppdater eksisterande prøvedata' : 'Registrer prøver på tvers av stasjonar'}
      </p>
    </div>
  );
};

export default PageHeader;
